import { createElement } from "react";
import { ButtonGroup, FlexMixin } from "@zillow/constellation";
import { negativeMarginMixin } from "@zillow/zrs-cms";
import styled from "styled-components";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const StyleButtonGroup = /* @__PURE__ */ styled(ButtonGroup).withConfig({
  displayName: "ButtonGroup__StyleButtonGroup",
  componentId: "sc-zexth1-0"
})(["", " ", " ", " ", " ", ""], FlexMixin, negativeMarginMixin, (props) => {
  var _a;
  if (!props.conjoined) return "";
  const isColumn = ["column", "column-reverse"].includes(((_a = props.direction) == null ? void 0 : _a.default) ?? "");
  const selector = `[data-c11n-component="Button.Root"], [data-c11n-component="TextButton.Root"]`;
  return isColumn ? `${selector} {
                   border-radius: 0;
                   margin-top: -1px;
               }
               ${selector}:first-child {
                   margin-top: 0;
                   border-top-left-radius: 4px;
                   border-top-right-radius: 4px;
               }
               ${selector}:last-child {
                   border-bottom-left-radius: 4px;
                   border-bottom-right-radius: 4px;
               }` : `${selector} {
                   border-radius: 0;
                   margin-left: -1px;
               }
               ${selector}:first-child {
                   margin-left: 0;
                   border-top-left-radius: 4px;
                   border-bottom-left-radius: 4px;
               }
               ${selector}:last-child {
                   border-top-right-radius: 4px;
                   border-bottom-right-radius: 4px;
               }`;
}, (props) => {
  const sel = `[data-c11n-component="Button.Root"], [data-c11n-component="TextButton.Root"]`;
  const on = `${sel} { flex-basis: 100%; flex-grow: 1; }`;
  const off = `${sel} { flex-basis: auto; flex-grow: 0; }`;
  const {
    default: def = false,
    lg_lte,
    sm_lte
  } = props.fluid ?? {};
  const parts = [def ? on : ""];
  if (sm_lte !== void 0) {
    parts.push(`@media (max-width: 480px) { ${sm_lte ? on : off} }`);
  }
  if (lg_lte !== void 0) {
    const minClause = sm_lte !== void 0 ? " and (min-width: 481px)" : "";
    parts.push(`@media (max-width: 1023px)${minClause} { ${lg_lte ? on : off} }`);
  }
  return parts.filter(Boolean).join("\n");
}, (props) => {
  if (props.conjoined) return "";
  const sel = `[data-c11n-component="Button.Root"], [data-c11n-component="TextButton.Root"]`;
  const first = `[data-c11n-component="Button.Root"]:first-child, [data-c11n-component="TextButton.Root"]:first-child`;
  const rowGap = `${sel} { margin-left: 8px; margin-top: 0; } ${first} { margin-left: 0; }`;
  const colGap = `${sel} { margin-top: 8px; margin-left: 0; } ${first} { margin-top: 0; }`;
  const isCol = (d) => ["column", "column-reverse"].includes(d);
  const {
    default: def = "row",
    lg_lte,
    sm_lte
  } = props.direction ?? {};
  const parts = [isCol(def) ? colGap : rowGap];
  if (sm_lte) {
    parts.push(`@media (max-width: 480px) { ${isCol(sm_lte) ? colGap : rowGap} }`);
  }
  if (lg_lte) {
    const minClause = sm_lte ? " and (min-width: 481px)" : "";
    parts.push(`@media (max-width: 1023px)${minClause} { ${isCol(lg_lte) ? colGap : rowGap} }`);
  }
  return parts.join("\n");
});
const BlockButtonGroup = ({
  attrs: {
    margin,
    justifyContent = {
      default: "flex-start"
    },
    alignItems = {
      default: "flex-start"
    },
    fluid = {
      default: false
    },
    direction = {
      default: "row"
    },
    conjoined = false,
    ...attrs
  },
  index,
  innerBlocks
}) => /* @__PURE__ */ createElement(StyleButtonGroup, { justifyContent, alignItems, fluid, direction, conjoined, ...attrs, ...margin, key: index }, generateBlockList({
  blocks: innerBlocks
}));
export {
  BlockButtonGroup as default
};
